<template>
  <div>
    <b-row class="justify-content-center mb-4">
      <b-col cols="12" sm="6">
        <label class="w-100">{{ $t("catalogs.Les_pouvoirs_sont_conditionnés") }}</label>
        <b-form-checkbox
          :value="1"
          :unchecked-value="0"
          :checked="building.voting_limit"
          class="d-inline"
          switch
          @change="updateBuilding('voting_limit', $event)"
        />
      </b-col>
    </b-row>
    <b-row v-if="!building.voting_limit" class="justify-content-center">
      <b-col cols="12" sm="8">
        <hr />
        <p class="px-2">
          Si sélectionné, les pouvoirs sont limités par l'article 22 de la loi du 10 juillet 1965 :
          "un mandataire ne peut recevoir plus de trois délégations de vote que si le total des voix
          dont il dispose lui-même et de celles de ses mandants n'excède pas 10% de voix du
          syndicat", mais vous pouvez modifier si nécessaire.
        </p>
      </b-col>
    </b-row>
    <b-row v-if="building.voting_limit" class="justify-content-center mb-3">
      <b-col cols="12" sm="6">
        <label>Pouvoirs par mandataire</label>

        <ValidationProvider
          ref="vee-building-votes-per-mandate"
          v-slot="{ errors, classes }"
          :name="'pouvoirs par mandataire'"
          rules="required|min_value:0"
        >
          <b-input
            class="w-25"
            type="number"
            :value="building.votes_per_mandate"
            @input="updateBuilding('votes_per_mandate', $event ? Number($event) : null)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row v-if="building.voting_limit" class="justify-content-center">
      <b-col cols="12" sm="6">
        <b-form-select
          class="w-auto mr-2"
          :value="building.voting_limit_operator"
          :options="votingLimitOperatorOptions"
          @change="updateBuilding('voting_limit_operator', $event)"
        />
        <span>
          <font-awesome-icon icon="info-circle" />
          {{ $t("catalogs.Possibilité_de_combiner_les_deux") }}
        </span>
      </b-col>
    </b-row>
    <b-row v-if="building.voting_limit" class="justify-content-center mt-3">
      <b-col cols="12" sm="6">
        <label>Pourcentage de voix du syndicat</label>

        <b-form-checkbox
          :value="1"
          :unchecked-value="0"
          :checked="building.voting_includes_mandates"
          class="ml-2 float-right"
          switch
          @change="updateBuilding('voting_includes_mandates', $event)"
        />
        <label class="float-right">{{ $t("catalogs.Mandataire_inclus") }}?</label>

        <ValidationProvider
          ref="vee-building-parts-per-mandate"
          v-slot="{ errors, classes }"
          :name="'pourcentage de voix du syndicat'"
          rules="required|min_value:0|max_value:100"
        >
          <div class="input-percent">
            <b-input
              type="number"
              :value="building.parts_per_mandate"
              @input="updateBuilding('parts_per_mandate', $event ? Number($event) : null)"
            />
            <span>%</span>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
        <div class="my-5">
          <font-awesome-icon icon="info-circle" />
          Par exemple 3 pouvoirs par mandataire OU 10% de voix du syndicat.
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { votingLimitOperatorOptions } from "@/constants/building.js";

export default {
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      votingLimitOperatorOptions,
    };
  },
  watch: {
    "building.voting_limit"(val) {
      if (!val) {
        this.updateBuilding("votes_per_mandate", 3); // DEFAULT
        this.updateBuilding("voting_limit_operator", 2); // DEFAULT
        this.updateBuilding("voting_includes_mandates", 1); // DEFAULT
        this.updateBuilding("parts_per_mandate", 10); // DEFAULT
      }
    },
  },
  methods: {
    updateBuilding(key, value) {
      this.$emit("updateBuilding", key, value);
    },
  },
};
</script>
